import React from "react";
import { ResearchFooter as ResearchFooterBase } from "@atlas-int/ui";
import { logos } from "../../assets/icons";

const ResearchFooter: React.FC = () => (
  <ResearchFooterBase
    vizHubIconSrc={logos.vizHubIcon}
    glLogoSrc={logos.glLogoBlack}
  />
);

export default ResearchFooter;
